import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { down } from '../../styles/media';

export const FooterBox = styled.footer`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  /* Verde escuro institucional, como no desenho do rodapé. O bloco inteiro
     inverte a polaridade -- texto claro sobre escuro --, então as cores de
     texto, ícone e borda daqui para baixo são todas sobre fundo escuro.
     O rodapé é global (App.js): esta cor vale para o site inteiro. */
  background: #0E4025;
  border-top: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Inter', sans-serif;
  margin-top: 0;
`;

export const TopPage = styled.button`
  /* Branca, como o rodapé escuro pede. A borda existe porque o botão fica na
     FRONTEIRA: metade dele cai sobre a seção clara, e sem ela essa metade
     desapareceria no branco. */
  background: var(--white-color, #fff);
  border: 1px solid rgba(14, 64, 37, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: absolute;
  top: -24px;
  left: 50%;
  transform: translateX(-50%);
  /* Acima da tela de carregamento (z 5, na área do conteúdo), que termina na
     borda do rodapé: a metade de cima do botão cai sobre ela. */
  z-index: 10;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);

  svg {
    height: 30px;
    width: 30px;
    /* Verde escuro do rodapé: 8.2:1 sobre o branco da bolinha. */
    color: #0E4025;
    transition: transform 0.2s ease;
  }

  @media (hover: hover) {
    &:hover {
      transform: translateX(-50%) translateY(-3px) scale(1.08);
      /* No hover ela vira verde e a seta branca: a inversão marca o estado
         sem mexer no tamanho. */
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
      background: #0E4025;
      border-color: #0E4025;

      svg {
        transform: translateY(-2px);
        color: var(--white-color, #fff);
      }
    }
  }

  &:active {
    transform: translateX(-50%) translateY(0) scale(0.96);
  }
`;

export const FooterContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 30px 24px 10px;
  box-sizing: border-box;
  width: 100%;

  ${down('lg')} {
    padding: 34px 24px 18px;
  }

  ${down('sm')} {
    padding: 30px 18px 16px;
  }
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 1.4fr repeat(4, 1fr);
  gap: 2.5rem 2rem;
  align-items: start;
  width: 100%;
  box-sizing: border-box;

  ${down('xl')} {
    grid-template-columns: 1.25fr repeat(4, 1fr);
    gap: 2rem 1.25rem;
  }

  /* Em tablets: 2 colunas centralizadas */
  ${down('lg')} {
    grid-template-columns: repeat(2, minmax(0, 16rem));
    justify-content: center;
    gap: 2.25rem 2rem;
  }

  /* Celular médio */
  ${down('sm')} {
    grid-template-columns: repeat(2, minmax(0, 14rem));
    gap: 2rem 1.5rem;
  }

  /* Celular pequeno (<600px): 1 coluna centralizada */
  @media (max-width: 37.5rem) {
    grid-template-columns: minmax(0, 20rem);
    justify-content: center;
    gap: 1.75rem;
  }
`;

export const BrandColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  ${down('lg')} {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem 2rem;
    align-items: start;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  }

  ${down('sm')} {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding-bottom: 1.25rem;
  }

  @media (max-width: 37.5rem) {
    align-items: center;
    text-align: center;
  }
`;

export const BrandInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 37.5rem) {
    align-items: center;
  }
`;

export const BrandLogo = styled.div`
  cursor: pointer;
  display: inline-block;
  width: fit-content;

  img {
    /* width e não max-width: o arquivo é um SVG de 129px de largura natural,
       e max-width só LIMITA -- com 190 ali a logo continuava saindo em 129.
       Sendo vetor, subir para 190 não perde nitidez.
       O max-width: 100% fica como teto, para ela nunca vazar da coluna no
       celular. */
    width: 190px;
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Sem efeito no hover. O cursor de mão já diz que é clicável, e escurecer
     a marca da cooperativa ao passar o mouse é chamar atenção para o lugar
     errado. */
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;

  @media (max-width: 37.5rem) {
    align-items: center;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8125rem;
  line-height: 1.45;

  svg {
    font-size: 1.05rem;
    color: rgba(255, 255, 255, 0.85);
    flex-shrink: 0;
    margin-top: 0.1rem;
  }

  span {
    flex: 1;
  }
`;

export const ContactItemLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8125rem;
  line-height: 1.45;
  text-decoration: none;
  transition: all 0.2s ease;
  width: fit-content;

  svg {
    font-size: 1.05rem;
    color: rgba(255, 255, 255, 0.85);
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  /* Sobre escuro o realce é clarear, não escurecer. E o negrito saiu: em
     fundo escuro ele engorda a letra e suja a leitura. */
  &:hover {
    color: var(--white-color, #fff);

    svg {
      transform: scale(1.15);
      color: var(--white-color, #fff);
    }
  }
`;

export const SocialNetworksBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  margin-top: 0.25rem;

  ${down('lg')} {
    margin-top: 0;
  }

  @media (max-width: 37.5rem) {
    align-items: center;
  }
`;

export const SocialTitle = styled.p`
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--white-color, #fff);
  margin: 0;
`;

export const SocialNetworks = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const SocialButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  /* O ícone já nasce branco: antes ele era escuro e só invertia no hover.
     Sobre fundo escuro o estado normal é o invertido. */
  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
    filter: brightness(0) invert(1);
    opacity: 0.9;
    transition: opacity 0.2s ease;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.35);
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

    img {
      opacity: 1;
    }
  }
`;

export const NavColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;

  @media (max-width: 37.5rem) {
    align-items: center;
    text-align: center;
  }
`;

export const ColumnTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 700;
  /* O verde da paleta. Ele só passa no contraste porque o fundo do rodapé é
     #0E4025: em #0E4025 dava 3.17:1 e reprovava o mínimo de 4.5; aqui dá
     4.53:1. Se o fundo clarear, este título tem de ser remedido. */
  color: #66B336;
  margin: 0;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  display: flex;
  align-items: center;
  min-height: 24px;

  @media (max-width: 37.5rem) {
    justify-content: center;
    width: 100%;
  }
`;

export const ColumnTitleLink = styled(Link)`
  font-size: 0.9375rem;
  font-weight: 700;
  /* O verde da paleta. Ele só passa no contraste porque o fundo do rodapé é
     #0E4025: em #0E4025 dava 3.17:1 e reprovava o mínimo de 4.5; aqui dá
     4.53:1. Se o fundo clarear, este título tem de ser remedido. */
  color: #66B336;
  margin: 0;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  text-decoration: none;
  display: flex;
  align-items: center;
  min-height: 24px;
  transition: all 0.2s ease;

  @media (max-width: 37.5rem) {
    justify-content: center;
    width: 100%;
  }

  &:hover {
    color: var(--white-color, #fff);
    transform: translateX(3px);
  }
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;

  @media (max-width: 37.5rem) {
    align-items: center;
  }
`;

export const NavLink = styled(Link)`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8125rem;
  line-height: 1.4;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  width: fit-content;

  @media (max-width: 37.5rem) {
    width: 100%;
    justify-content: center;
  }

  /* Sem negrito no hover: em fundo escuro ele engorda a letra, e somado ao
     deslocamento faz a linha inteira pular. */
  &:hover {
    color: var(--white-color, #fff);
    transform: translateX(4px);
  }
`;

export const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.06) 0%,
    rgba(255, 255, 255, 0.22) 50%,
    rgba(255, 255, 255, 0.06) 100%
  );
  margin-top: 36px;
  margin-bottom: 24px;
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.25rem;
  width: 100%;

  ${down('md')} {
    flex-direction: column-reverse;
    justify-content: center;
    text-align: center;
    gap: 1.5rem;
  }
`;

export const CopyrightText = styled.p`
  /* O desenho pede branco 55%, que dá 3.70:1 sobre este fundo e reprova o
     mínimo de 4.5. 70% dá 4.96:1 e continua sendo o texto mais apagado do
     rodapé, que é o papel dele. */
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.775rem;
  line-height: 1.5;
  margin: 0;

  ${down('md')} {
    text-align: center;
  }
`;

export const PartnersBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;

  ${down('md')} {
    justify-content: center;
  }
`;

export const PartnerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;

  .footer-logo {
    height: 32px;
    width: auto;
    max-width: 130px;
    object-fit: contain;
    display: block;
    /* As logos são PNG escuro com fundo transparente: sobre o verde escuro
       elas sumiriam. O invert as deixa brancas, que é como o desenho mostra
       -- e a sombra de antes, feita para fundo claro, sai. */
    filter: brightness(0) invert(1);
    opacity: 0.9;
    transition: transform 0.2s ease;
  }

  &:hover {
    transform: scale(1.06);

    .footer-logo {
      transform: scale(1.02);
      opacity: 1;
    }
  }
`;